import { getCurrentBrand } from '@/shared/config/brand-by-target.mjs';

export const getInfoDocsDirectory = (locale: string) => {
  const brand = getCurrentBrand();

  if (brand === 'lm') {
    return 'lm';
  }

  if (brand === 'ph' || brand === 'ph2') {
    return `${brand}-${locale}`;
  }

  return locale;
};
